module.exports = __webpack_public_path__ + "img/mg_share.597eaa57.png";